import styled from "@emotion/styled";

export const Text = styled.p``;
export const SaveModalContent = styled.div``;
